/* PagingNetworkDiscoveryResultsFeed.js */

"use strict";
const PagingFeed = require("../../../../lib/PagingFeed");
const _ = require("lodash");

class PagingNetworkDiscoveryResultsFeed extends PagingFeed {
    _getFeed() {
        return this._EntityDef.startNetworkDiscoveryResultsFeed(
            this._activeOrgId,
            this._filter,
            this._entityFields,
            this._sort,
            {skip: 0, limit: this._pageSize * 2}
        );
    }

    setQuery(query) {
        this._query = query;
    }

    _resultsFeedReestablish() {
        return this.feedUpdate();
    }

    _getDistinctValuesOfField(tenantId, field) {
        return this._relatedEntityDef.startNetworkDiscoveryExecutionDistinctValuesFeed(
            tenantId,
            field
        );
    }

    _getFeedIdsForSelection(tenantId, selection) {
        if (_.get(selection, "range.all", false)) {
            return this._EntityDef
                .loadNetworkDiscoveryResults(tenantId, this._filter, {id: true})
                .then((results) => {
                    return results.map((result) => {
                        return result.id;
                    });
                });
        } else {
            return this._EntityDef.loadNetworkDiscoveryResultIdsForSelection(tenantId, selection);
        }
    }

    getNetworkDiscoveryResultsEntitiesById(ids) {
        return this.getEntitiesById(ids);
    }

    getDeviceEntitiesNameById(ids) {
        return this.getEntitiesValueById(ids, "deviceName");
    }

    getDeviceEntityById(id) {
        return this.getEntityById(id);
    }
}

module.exports = PagingNetworkDiscoveryResultsFeed;
